import { render, staticRenderFns } from "./businessLicenseInfo.vue?vue&type=template&id=32d808e2&scoped=true&"
import script from "./businessLicenseInfo.vue?vue&type=script&lang=js&"
export * from "./businessLicenseInfo.vue?vue&type=script&lang=js&"
import style0 from "./businessLicenseInfo.vue?vue&type=style&index=0&id=32d808e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d808e2",
  null
  
)

export default component.exports